import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  IconButton,
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { message, Modal } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PageTitle from "../../Components/PageTitle";
import Table from "../common/Table";
import EditAcademicCalendar from "./EditAcademicCalendar";
import axios from "../../axiosInstance";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AcademicCalendar = () => {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");
  const [academicCalendar, setAcademicCalendar] = useState([]);
  const [filteredAcademic, setFilteredAcademic] = useState([]);
  const [name, setName] = useState("");
  const [event, setEvent] = useState("");
  const [date, setDate] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleStartDateChange = (date) => {
    setDate(date);
  };

  // Get Data Academic Calendar
  const getAcademicCalendar = async () => {
    try {
      const response = await axios.get("/api/v1/academic-calendar/get");
      setAcademicCalendar(response.data?.academicCalendar);
      setFilteredAcademic(response.data?.academicCalendar);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    getAcademicCalendar();
  }, []);

  // Function to refresh the academic calendar data
  const refreshData = () => {
    getAcademicCalendar(); // Refresh data after update
  };

  // Handle search input change
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // Filter academic calendar based on search query
  const filteredNewAcademic = filteredAcademic?.filter(
    (academic) =>
      academic?.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
      academic?.event?.toLowerCase()?.includes(search?.toLowerCase())
  );

  // Handle Delete Api Academic Calendar
  const { confirm } = Modal;
  const handleDeleteAcademicCalendar = async (id) => {
    confirm({
      title: "Are you sure you want to delete this Academic Calendar?",
      content: "Once deleted, this course cannot be recovered.",
      okText: "Yes, Delete",
      cancelText: "No, Cancel",
      onOk: async () => {
        try {
          const response = await axios.delete(
            `/api/v1/academic-calendar/admin-delete`,
            { data: { id } }
          );
          // Check if the response is successful
          if (response.data.success === true) {
            message.success(
              response.data.message || "Academic Calendar deleted successfully"
            );
            getAcademicCalendar();
          } else {
            message.error("Failed to delete Academic Calendar");
          }
        } catch (error) {
          message.error(
            error.response.data.message || "Error deleting academic calendar"
          );
        }
      },
    });
  };

  const eventDate = moment(date).format("MM/DD/YYYY");

  // Handle Api Academic Calendar
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      message.error("Please enter a academic calendar name");
      return;
    }

    if (!date) {
      message.error("Please select a event start date");
      return;
    }
    if (!event) {
      message.error("Please select a academic calendar event");
      return;
    }
    const handleAcademicCalendarData = {
      name,
      event,
      date: eventDate,
    };

    try {
      const response = await axios.post(
        "/api/v1/academic-calendar/admin-add",
        handleAcademicCalendarData
      );
      // Check if the response is successfuls
      if (response.data.success === true) {
        message.success(
          response.data.message || "Academic Calendar created successfully"
        );
        getAcademicCalendar();
      } else {
        message.error("Failed to create Academic Calendar");
      }
    } catch (error) {
      message.error(
        error.response.data.message || "Error creating academic calendar"
      );
    }
    // Reset form fields
    setName("");
    setEvent("");
    setDate(null);
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "Actions",
      width: 120,
      renderCell: (value) => (
        <Box>
          <IconButton
            aria-label="delete"
            onClick={() => handleDeleteAcademicCalendar(value?.row?._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
          <EditAcademicCalendar
            id={value?.row?._id}
            CalendarName={value?.row?.name}
            CalendarEvent={value?.row?.event}
            CalendarDate={value?.row?.date}
            refreshData={refreshData}
          />
        </Box>
      ),
    },

    {
      field: "name",
      headerName: "Name",
      width: 180,
      editable: true,
    },
    {
      field: "event",
      headerName: "Event",
      width: 350,
      renderCell: (params) => (
        <div
          style={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
          }}
          dangerouslySetInnerHTML={{ __html: params.row.event }}
        />
      ),
    },

    {
      field: "date",
      headerName: "Event Start Date",
      width: 170,
      editable: true,
    },

    {
      field: "createdAt",
      headerName: "CreatedAt",
      width: 150,
      renderCell: (params) =>
        moment(params?.row?.createdAt).format("MM/DD/YYYY"),
    },
  ];

  return (
    <>
      <PageTitle
        title="Manage School Calendar - Admin Panel | Shree Mangalam School"
        description="Add and update important academic dates, holidays, and schedules through the Admin Panel of Shree Mangalam School. Ensure timely communication with students and parents."
        url="/admin/academic-calendar"
        keywords="academic calendar admin, school calendar management, Shree Manglam academic dates, manage holidays, admin schedule updates, event calendar admin"
      />

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          mb: 3,
          fontFamily: "Poppins, sans-serif",
          color: "#2C3E50",
          letterSpacing: "2.5px",
          lineHeight: 1.8,
        }}
      >
        Academic Calendar
      </Typography>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          mb: 5,
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "primary.main" }}>
          Academic Calendar
        </Typography>
      </Breadcrumbs>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Event List" {...TabPanel(0)} />
          <Tab label="Add Event" {...TabPanel(1)} />
        </Tabs>
      </Box>
      {/* Events & News List */}
      <CustomTabPanel value={value} index={0}>
        <Typography
          variant="h6"
          sx={{
            pb: 2,
            pt: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#555",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          Event List
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search by Name or Event"
          value={search}
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <IconButton>
                <SearchIcon sx={{ color: "#1976d2" }} />
              </IconButton>
            ),
          }}
          sx={{
            mb: 3,
            mt: 2,
            bgcolor: "white",
            borderRadius: "20px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none",
              },
              "&:hover fieldset": {
                border: "none",
              },
              "&.Mui-focused fieldset": {
                border: "none",
              },
            },
          }}
        />
        <Table data={filteredNewAcademic} columns={columns} />
      </CustomTabPanel>

      {/* Create a New Add Events & News */}
      <CustomTabPanel value={value} index={1} maxWidth>
        <Typography
          variant="h6"
          sx={{
            pb: 2,
            pt: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#555",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          Create a new Event
        </Typography>
        <Container
          onSubmit={handleSubmit}
          component="form"
          className="form_style border-style"
          maxWidth
        >
          <h4>Event Name</h4>
          <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
            <InputLabel id="event-name-label">Event Name *</InputLabel>
            <Select
              labelId="event-name-label"
              id="EventName"
              name="eventName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              label="Event Name *"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="School">School</MenuItem>
              <hr />
              <MenuItem value="RIMC">RIMC</MenuItem>
              <MenuItem value="Navodaya">Navodaya</MenuItem>
              <MenuItem value="Sainik">Sainik</MenuItem>
              <MenuItem value="Military">Military</MenuItem>
            </Select>
          </FormControl>

          <h4>Event Description </h4>
          <ReactQuill
            value={event}
            onChange={setEvent}
            placeholder="Event"
            style={{
              // height: "200px",
              marginBottom: "30px",
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "10px",
            }}
          />

          <Box className="Date">
            <Box sx={{ mt: 3 }}>
              <h4>Event Date</h4>
              <DatePicker
                showIcon
                toggleCalendarOnIconClick
                isClearable
                placeholderText="Event Date"
                selected={date}
                onChange={handleStartDateChange}
                minDate={new Date()}
                maxDate={date}
                value={date}
              />
            </Box>
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="courses_desc"
            sx={{
              mt: 3,
              borderRadius: "5px",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              letterSpacing: ".1rem",
            }}
          >
            Add Event
          </Button>
        </Container>
      </CustomTabPanel>
    </>
  );
};

export default AcademicCalendar;
